import { render, staticRenderFns } from "./EpiteliumGameComp.vue?vue&type=template&id=738c13f2&scoped=true"
import script from "./EpiteliumGameComp.vue?vue&type=script&lang=js"
export * from "./EpiteliumGameComp.vue?vue&type=script&lang=js"
import style0 from "./EpiteliumGameComp.vue?vue&type=style&index=0&id=738c13f2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "738c13f2",
  null
  
)

export default component.exports